module.exports = __webpack_public_path__ + "assets/img/ndbg1.9fb78eee.png";